// extracted by mini-css-extract-plugin
export default {"cardHeader":"ordercreate_cardHeader__6TC0Q","myCardBlock":"ordercreate_myCardBlock__eDEte"};